import React from "react";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import { CHAT_DUOTONE_ICON, PHONE_DUOTONE_ICON } from "../../utils/svgs_duotone";
import { withDefault } from "../../utils/withDefault";
import { AppButton } from "../Generic/AppButton";
import { AppIcon } from "../Generic/AppIcon";
import AsyncImage from "../Generic/AsyncImage";
import Flex from "../Generic/Flex";
import { IsDefined } from "../Generic/IsDefined";

interface Props {
  agency: { name: string; logoUrl: string | null };
  prefix?: string;
  showCallButton?: boolean;
  onClickChat: () => void;
  onClickCall: () => void;
}

const ContactAgency = (props: Props) => {
  const logo = React.useMemo(() => {
    return (
      <IsDefined value={props.agency.logoUrl}>
        {(logoUrl) => <AsyncImage src={logoUrl} className="__logo" />}
      </IsDefined>
    );
  }, [props.agency.logoUrl]);

  const nameWithPrefix = React.useMemo(() => {
    return (
      <Flex direction="column">
        <h4>{withDefault(props.prefix, translate(STRINGS.BY))}</h4>
        <h2>{props.agency.name}</h2>
      </Flex>
    );
  }, [props.prefix, props.agency.name]);

  return (
    <div className="ContactAgency">
      <Flex direction="column" yGap={24}>
        <Flex alignItems="center" xGap={16}>
          {logo}
          {nameWithPrefix}
        </Flex>

        <Flex direction="column" yGap={16}>
          <AppButton variant="filled" color="primary" onClick={props.onClickChat}>
            <AppIcon icon={CHAT_DUOTONE_ICON} fill="white" size={20} />
            <span>{translate(STRINGS.CHAT_WITH_AGENCY)}</span>
          </AppButton>

          {props.showCallButton !== false && (
            <AppButton
              variant="filled"
              color="white"
              textColor="primary"
              onClick={props.onClickCall}
            >
              <AppIcon icon={PHONE_DUOTONE_ICON} fill="white" size={20} />
              <span>{translate(STRINGS.CALL_AGENCY)}</span>
            </AppButton>
          )}
        </Flex>
      </Flex>
    </div>
  );
};

export default ContactAgency;
